import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useState } from 'react';
import { dashboardActions } from '../../../../store/slices/dashboardSlice/dashboardSlice';
import { createManager } from '../../../../store/slices/dashboardSlice/action';
import { ManagerInformation } from '../../types/dashboardInformation';

export interface ErrorsMessage {
    name: string;
    email: string;
}

export const useModalAddManagerInfo = () => {
    const dispatch = useDispatch();
    const { modalMode, currentManagerId, modalLoader } = useSelector(
        //@ts-ignore
        (state) => state.dashboardReducer
    );
    const [errorsMessage, setErrorsMessage] = useState<ErrorsMessage>({ name: null, email: null });
    const [form, setForm] = useState<ManagerInformation>({
        full_name: '',
        position: '',
        email: '',
        phone: '',
        preview_url: '',
    });

    const onForm = useCallback(
        (name: string, value: string) => {
            setForm({ ...form, [name]: value });
        },
        [form]
    );

    const onCancel = useCallback(() => {
        dispatch(dashboardActions.onModalMode(null));
        setForm({
            full_name: '',
            position: '',
            email: '',
            phone: '',
            preview_url: '',
        });
    }, [modalMode, currentManagerId]);

    const onSubmit = useCallback(() => {
        if (validateForm()) {
            dispatch(dashboardActions.onModalLoader(true));
            dispatch(createManager(form))
                .unwrap()
                .then((res) => {
                    if (res.status === 'success') {
                        dispatch(dashboardActions.onModalLoader(false));
                        setForm({
                            full_name: '',
                            position: '',
                            email: '',
                            phone: '',
                            preview_url: '',
                        });
                    }
                });
        }
    }, [form]);

    const validateForm = () => {
        const newErrors: ErrorsMessage = {} as ErrorsMessage;
        if (!form.full_name.trim()) {
            newErrors.name = i18next.t('useModalAddManagerInfo.validateForm.name');
        }
        if (!form.email.trim()) {
            newErrors.email = i18next.t('useModalAddManagerInfo.validateForm.email');
        }
        if (form.email.trim() && !/\S+@\S+\.\S+/.test(form.email)) {
            newErrors.email = i18next.t('useModalAddManagerInfo.validateForm.unCorrectEmail');
        }
        setErrorsMessage(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return {
        onCancel,
        modalMode,
        onForm,
        form,
        onSubmit,
        errorsMessage,
        modalLoader,
    };
};
